// 파티클 효과 생성 함수
export const createParticles = (x, y, color, count = 20) => {
  const particles = [];
  
  for (let i = 0; i < count; i++) {
    // 랜덤 방향과 속도로 파티클 생성
    const angle = Math.random() * Math.PI * 2;
    const speed = 2 + Math.random() * 3;
    const size = 3 + Math.random() * 5;
    const duration = 500 + Math.random() * 1000; // 0.5초 ~ 1.5초
    
    const particle = document.createElement('div');
    particle.className = 'particle';
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.backgroundColor = color;
    particle.style.left = `${x}px`;
    particle.style.top = `${y}px`;
    particle.style.setProperty('--x', `${Math.cos(angle) * speed * 50}px`);
    particle.style.setProperty('--y', `${Math.sin(angle) * speed * 50}px`);
    particle.style.animationDuration = `${duration}ms`;
    
    particles.push(particle);
  }
  
  return particles;
};

// 로컬 스토리지 유틸리티 함수
export const saveToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error('로컬 스토리지 저장 오류:', error);
    return false;
  }
};

export const loadFromLocalStorage = (key, defaultValue = null) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : defaultValue;
  } catch (error) {
    console.error('로컬 스토리지 로드 오류:', error);
    return defaultValue;
  }
};

// 점수 계산 유틸리티 함수
export const calculateScore = (blocksCount, combo, hasSpecialBlocks) => {
  const basePoints = blocksCount * 10;
  const comboBonus = combo > 1 ? (combo - 1) * 5 : 0;
  const specialBonus = hasSpecialBlocks ? 50 : 0;
  
  return basePoints + comboBonus + specialBonus;
};

// 난이도 조정 함수
export const getDifficultySettings = (level) => {
  // 레벨에 따라 게임 난이도 설정 반환
  const settings = {
    specialBlockChance: Math.min(0.05 + (level * 0.01), 0.2), // 최대 20%
    timeLimit: Math.max(60 - (level * 2), 30), // 최소 30초
    minMatchSize: 3,
    colors: ['red', 'blue', 'green', 'yellow', 'purple', 'orange']
  };
  
  // 레벨 7부터 색상 추가
  if (level >= 7) {
    settings.colors.push('pink');
  }
  
  return settings;
};

// 모바일 디바이스 감지 함수
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
         (window.innerWidth <= 768);
};

// 게임 상태 초기화 함수
export const initializeGameState = (mode) => {
  return {
    score: 0,
    combo: 0,
    timeLeft: mode === 'zen' ? Infinity : 60,
    level: 1,
    gameMode: mode,
    isPlaying: true,
    lastMatchTime: Date.now()
  };
};
